import { useTranslation } from "react-i18next";
import React, { useEffect, useState, Fragment, useRef } from "react";
import apiRequest from "../../functions/api";
import LoadingComponent from "../LoadingComponent/LoadingComponent";
import axios from "axios";
import { API_BASE_URL } from "../../constants/apiConstants";
import {
  Grid,
  Hidden,
  Box,
  Button,
  Table,
  TableRow,
  TableHead,
  TableCell,
  TableBody,
} from "@mui/material";
import ResponsiveDialog from "../shared/components/ResponsiveDialog";
import { useMessage } from "../../context/message-context";
import { DateTextField, SearchTextField } from "../lib";
import openFile from "../shared/functions/download";
import { useNavigate } from "react-router-dom";
import { FullPageSpinner } from "../lib";
import MonthTextField from "../shared/components/MonthTextField";
function Auswertungsdruck(props) {
  const { t } = useTranslation();
  const { client, accessToken } = props;
  const [isLoading, setIsLoading] = useState(false);
  const { showErrorMessage, showInfoMessage } = useMessage();
  const [auswertung, setAuswertung] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();
  const [open, setOpen] = useState(0);
  const ind = useRef(-1);
  const ind2 = useRef(-1);
  const [filter, setFilter] = useState("");
  const [test, setTest] = useState("202407");
  useEffect(() => {
    setIsLoading(true);
    const payload = {
      mandant: client, // this.props.client,
      program: location.pathname === "/WEBAD3" ? "WEBAD3" : "WEBAD2",
      statement: "UEBERSICHT",
    };
    const headers = {
      Authorization: "Bearer " + accessToken,
    };
    apiRequest("POST", "daten", payload, headers, postUebersicht);
    // eslint-disable-next-line
  }, []);
  const postUebersicht = (response) => {
    setIsLoading(false);
    if (response.status === 200) {
      setAuswertung(response.data.auswertung);
    } else {
      if (response) {
        showErrorMessage(response.data.message);
      } else {
        showErrorMessage(t("Keine Internetverbindung"));
      }
    }
  };
  if (isLoading) {
    return <LoadingComponent path={props.location} />;
  }
  function onChange(index, value) {
    var tmpliste = [...auswertung];
    tmpliste[ind.current].liste[ind2.current].fragen[index].antwort = value;
    setAuswertung(tmpliste);
  }
  function Abbrechen() {
    setOpen(0);
    ind.current = -1;
    ind2.current = -1;
  }
  const closeModal = () => {
    setShowModal(false);
  };
  function AuswertungStarten() {
    setShowModal(true);
    downloadFile();
    Abbrechen();
  }
  const downloadFile = () => {
    const payload = {
      mandant: client,
      program: location.pathname === "/WEBAD3" ? "WEBAD3" : "WEBAD2",
      statement: "EXCEL",
      auswertung: auswertung,
      index: (ind.current + 1).toString(),
      index2: (ind2.current + 1).toString(),
      len: auswertung[ind.current].liste[ind2.current].fragen.length.toString(),
    };
    const headers = {
      Authorization: "Bearer " + accessToken,
      Accept: "application/pdf",
    };
    axios
      .post(API_BASE_URL + "daten", payload, {
        headers: headers,
        responseType: "blob",
      })
      .then((response) => {
        console.log(response);
        var fileName = "Auswertung.xlsx";
        var contentFile = response.data;
        const mimeType = response.headers["content-type"] || "application/pdf";
        openFile(fileName, contentFile, mimeType);
        closeModal();
      })
      .catch(async function (error) {
        if (error.response.data instanceof Blob) {
          const blob = new Blob([error.response.data]);
          const data = await blob.text();
          const { message } = JSON.parse(data);
          showInfoMessage(message);
        } else {
          showErrorMessage(
            t(
              "Ein Fehler ist aufgetreten. Bitte versuchen Sie den download erneut."
            )
          );
        }
        closeModal();
      });
  };
  function Auswahl(index, index2) {
    ind.current = index;
    ind2.current = index2;
    if (
      auswertung[index].liste[index2].fragen &&
      auswertung[index].liste[index2].fragen.length > 0
    ) {
      setOpen(1);
    } else {
      AuswertungStarten();
    }
  }
  function AnzeigeTable() {
    return (
      <Fragment>
        <Box p={2}>
          <SearchTextField
            size="small"
            fullWidth
            label={t("Suche")}
            id="filter"
            variant="outlined"
            value={filter}
            inputProps={{
              autoCapitalize: "off",
              autoCorrect: "off",
              spellCheck: "false",
              autoComplete: "off",
            }}
            onChange={(e) => setFilter(e.target.value)}
          />
        </Box>
        <Table container>
          <Table size="small">
            <TableHead>
              <TableRow key="header">
                <Hidden lgDown>
                  <TableCell>{t("Key")}</TableCell>
                  <TableCell>{t("Bezeichnung")}</TableCell>
                  <TableCell>{t("Kategorie")}</TableCell>
                  <TableCell>{t("Art")}</TableCell>
                </Hidden>
              </TableRow>
            </TableHead>
            {AnzeigeBody()}
          </Table>
        </Table>
      </Fragment>
    );
  }
  function AnzeigeBody() {
    return (
      <Fragment>
        {auswertung &&
          auswertung.length > 0 &&
          auswertung.map((item, index) => {
            return (
              <Fragment>
                <TableHead>
                  <TableRow key={"header" + index.toString()}>
                    <TableCell align="center" colSpan={4}>
                      {item.bez}
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {item.liste &&
                    item.liste.length > 0 &&
                    item.liste
                      .filter((item2) => {
                        if (
                          item2.key
                            .toLowerCase()
                            .includes(filter.toLowerCase()) === false &&
                          item2.bez
                            .toLowerCase()
                            .includes(filter.toLowerCase()) === false &&
                          item2.art
                            .toLowerCase()
                            .includes(filter.toLowerCase()) === false &&
                          item.bez
                            .toLowerCase()
                            .includes(filter.toLowerCase()) === false
                        )
                          return false;
                        return true;
                      })
                      .map((item2, index2) => {
                        return (
                          <TableRow
                            style={{ cursor: "pointer" }}
                            onClick={() => Auswahl(index, index2)}
                            hover
                            key={item2.key}
                          >
                            <Hidden lgDown>
                              <TableCell>{item2.key}</TableCell>
                              <TableCell>{item2.bez}</TableCell>
                              <TableCell>{item.bez}</TableCell>
                              <TableCell>{item2.art}</TableCell>
                            </Hidden>
                            <Hidden lgUp>
                              <TableCell>
                                {item2.key}
                                <br />
                                {item2.bez}
                                <br />
                                {item2.art}
                              </TableCell>
                            </Hidden>
                          </TableRow>
                        );
                      })}
                </TableBody>
              </Fragment>
            );
          })}
      </Fragment>
    );
  }
  function AnzeigeFragen() {
    return (
      <ResponsiveDialog
        title={
          auswertung &&
          auswertung.length > 0 &&
          ind.current > -1 &&
          ind2.current > -1 &&
          auswertung[ind.current].liste[ind2.current].bez
        }
        open={open === 1}
        setOpen={() => Abbrechen()}
        actionButton={
          <Fragment>
            <Button color="primary" onClick={() => AuswertungStarten()}>
              {t("Starten")}
            </Button>
            <Button color="primary" onClick={() => Abbrechen()}>
              {t("Abbrechen")}
            </Button>
          </Fragment>
        }
      >
        <Box p={2}>
          <Grid container justifyContent="center" spacing={2}>
            {ind.current > -1 &&
              ind2.current > -1 &&
              auswertung[ind.current].liste[ind2.current].fragen &&
              auswertung[ind.current].liste[ind2.current].fragen.length > 0 &&
              auswertung[ind.current].liste[ind2.current].fragen.map(
                (item, index) => {
                  return (
                    <>
                      {item.art === "Datum" && (
                        <Grid item xs={12}>
                          <DateTextField
                            id={"frage" + index.toString()}
                            label={item.text}
                            fullWidth
                            onChange={(e) => onChange(index, e.target.value)}
                            value={item.antwort}
                            variant="outlined"
                            InputLabelProps={{
                              shrink: true,
                            }}
                          />
                        </Grid>
                      )}
                      {item.art === "Monat" && (
                        <Grid item xs={12}>
                          <MonthTextField
                            id={"frage" + index.toString()}
                            label={item.text}
                            fullWidth
                            onChange={(e) => onChange(index, e)}
                            value={item.antwort}
                            variant="outlined"
                            InputLabelProps={{
                              shrink: true,
                            }}
                          />
                        </Grid>
                      )}
                    </>
                  );
                }
              )}
          </Grid>
        </Box>
      </ResponsiveDialog>
    );
  }
  return (
    <Fragment>
      <Grid container justifyContent="center" spacing={2}>
        {AnzeigeFragen()}
        <Grid item xs={12} md={8}>
          {AnzeigeTable()}
        </Grid>
      </Grid>
      {showModal && <FullPageSpinner />}
    </Fragment>
  );
}
export default Auswertungsdruck;
